import React from "react";
import PdfInput from "./PdfInput";
import Heading from "./Heading";
import SideChat from "./chats/sidebarChat";
import Loading from "./Loading";

function BootstrapDisplay({
  getHighlightedText,
  getIsHighlightedText,
  getText,
  isChatLoading,
  firstPDFMessage,
  getUserMessage,
  chats,
  setReset,
  reset,
  PDF
}) {
  return (
    <div className="row" style={{ height: "100%" }}>
      <div
        className="col-md-8"
        style={{ height: "100%", backgroundColor: "#f0f0f0" }}
      >
        {/* Content for left column */}
        <PdfInput
          getHighlightedText={getHighlightedText}
          getIsHighlightedText={getIsHighlightedText}
          getText={getText}
        />
      </div>
      <div className="col" style={{ height: "100%", backgroundColor: "white" }}>
        {/* Content for right column */}
        <Heading
          title={"AI Chat"}
          subheading={
            "highlight text and ask specific questions about that text"
          }
        />

        <Heading title={"Chat with the PDF"} subheading={"Ask me anything"} />
        {/* {isChatLoading === 1 && <Loading />} */}
        <SideChat
          isChatLoading={isChatLoading}
          firstPDFMessage={firstPDFMessage}
          getUserMessage={getUserMessage}
          chats={chats}
          setReset={setReset}
          reset={reset}
          PDF={PDF}
        />
      </div>
    </div>
  );
}

export default BootstrapDisplay;
